/**
 * Membership tiers and entitlements — frontend mirror of
 * backend/src/config/entitlements.js. Keep the two in sync.
 *
 * - pre_alpha: everyone before launch. Full access, no ads.
 * - free:      post-launch free tier. Ads on, core lessons only.
 * - pro:       no ads + Game of Life + interactive (Workshop) lessons.
 */

const TIERS = ['pre_alpha', 'free', 'pro'];

const ENTITLEMENTS = {
  pre_alpha: { showAds: false, gameOfLife: true, interactiveLessons: true },
  free: { showAds: true, gameOfLife: false, interactiveLessons: false },
  pro: { showAds: false, gameOfLife: true, interactiveLessons: true }
};

export function normalizeTier(tier) {
  return TIERS.includes(tier) ? tier : 'pre_alpha';
}

/** Entitlements for a user object (uses membershipTier, defaults to pre_alpha). */
export function getEntitlements(user) {
  const tier = normalizeTier(user?.membershipTier);
  return { tier, ...ENTITLEMENTS[tier] };
}

export const TIER_LABELS = {
  pre_alpha: 'Pre-Alpha',
  free: 'Free',
  pro: 'Pro'
};

export { TIERS };
